module.exports = __webpack_public_path__ + "static/media/screwdriver.2ee9f9b2.svg";